export class EventDate {
    constructor(
        plannedDateTimeUtc: Date | null,
        plannedDateTimeLocal: Date | null,
        actualDateTimeUtc: Date | null,
        actualDateTimeLocal: Date | null
    ) {
        this.plannedDateTimeUtc = plannedDateTimeUtc;
        this.plannedDateTimeLocal = plannedDateTimeLocal;
        this.actualDateTimeUtc = actualDateTimeUtc;
        this.actualDateTimeLocal = actualDateTimeLocal;
    }
    plannedDateTimeUtc: Date | null;
    plannedDateTimeLocal: Date | null;
    actualDateTimeUtc: Date | null;
    actualDateTimeLocal: Date | null;
}
